import React from 'react';
import './CheckoutErrorNotice.css';

const CheckoutErrorNotice = ({ message, onRetry, retryLabel = 'Prøv igen' }) => {
  if (!message) return null;

  return (
    <div className="checkout-error-notice" role="alert">
      <p className="checkout-error-notice__text">{message}</p>
      {onRetry && (
        <button
          type="button"
          className="checkout-error-notice__retry"
          onClick={onRetry}
        >
          {retryLabel}
        </button>
      )}
    </div>
  );
};

export default CheckoutErrorNotice;
